// import {
//   Info as Icon // TODO: select an icon
// } from 'components/icons';

import { Icon } from "semantic-ui-react";

function TheIcon (props) {
  return <Icon name="lightning" {...props} />;
}

export const meta = {
  id: 'InteractiveDataStructure',
  title: 'InteractiveDataStructure',
  // category: 'xxxxx',
  // exposes: [
  //   {
  //     title: 'General',
  //     action: { module: 'InteractiveDataStructure', props: { /* */ } },
  //     desription: 'general-desc',
  //   },
  // ],
  unique: true,
  icon: TheIcon,
  version: '1.0.0',
  description: `This module allows users to make Data Structures manageable by a module of their own.'`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    // width: 630,
    // height: 380
  }
};
